module.exports = __webpack_public_path__ + "static/media/bgHatchEmbroidery03.d2cc550d.jpg";